import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http'
import {ApplicationConfig, inject, provideAppInitializer} from '@angular/core'
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field'
import {provideRouter, withHashLocation} from '@angular/router'
import routes from './app-routes'
import {AuthInterceptor} from './application/auth-interceptor'
import {CameraFactory} from './application/camera-factory.class'
import {CAMERA_FACTORY} from './application/camera.provider'
import {WINDOW} from './application/constants'
import {LOCAL_STORAGE_PROVIDERS} from './application/local-storage.provider'
import {ConfigService} from './services/config.service'
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async'
import {ResponseInterceptor} from './application/response.interceptor'

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(() => inject(ConfigService).bootstrap()),
    {provide: CAMERA_FACTORY, useClass: CameraFactory},
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: ResponseInterceptor, multi: true},
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        floatLabel: 'always',
        hideRequiredMarker: true,
        appearance: 'outline'
      }
    },
    LOCAL_STORAGE_PROVIDERS,
    {provide: WINDOW, useValue: window},
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),

    provideRouter(routes,
      withHashLocation())
  ]
}